import { ConfiguratedValidatorConstraintProvider } from './configurable-validation';
export const ClassValidatorProviders = [ConfiguratedValidatorConstraintProvider];